export const SIGNUP_PENDING_HEADQUARTERS_MARKER = "__GT_SIGNUP_PENDING__";

export function headquartersValueForForm(value: string | null | undefined): string {
  if (value == null || value === SIGNUP_PENDING_HEADQUARTERS_MARKER) return "";
  return value;
}

export function displayHeadquartersText(value: string | null | undefined): string {
  if (value == null || value.trim() === "") return "N/A";
  if (value === SIGNUP_PENDING_HEADQUARTERS_MARKER) return "N/A";
  return value;
}

export function formatHeadquartersLocationLine(
  city: string | null | undefined,
  country: string | null | undefined,
): string {
  const cityPending =
    !city || city.trim() === "" || city === SIGNUP_PENDING_HEADQUARTERS_MARKER;
  const countryPending =
    !country || country.trim() === "" || country === SIGNUP_PENDING_HEADQUARTERS_MARKER;
  if (!cityPending && !countryPending) return `${city}, ${country}`;
  if (!countryPending) return country!;
  if (!cityPending) return city!;
  return "N/A";
}
